<template>
    <div class="coursePullComponent" @click="goToCourse">
        <img :src="courseImage" alt="">
        <p v-if="type === 'help'">{{isBuy || helpStatus === 1 ? '（课程已领取 ，立即去听课）' : '（领取课程后，点击可查看课程详情）'}}</p>
    </div>
</template>
<script>
import { reqCourseDetail, reqIsBuyProduct } from '@/api/courseDetail';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      courseImage: null,
      isBuy: false,
    };
  },
  props: {
    productId: {
      type: Number,
    },
    productSkuId: {
      type: Number,
    },
    type: {
      type: String,
      default: 'home',
    },
    helpStatus: {
      default: null,
    },
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    async courseDetail() {
      const { data } = await reqCourseDetail(this.productId);
      this.courseImage = data.coverMobile;
      this.$emit('coursePullCb', true)
      //const productSkuInfo = data?.productSkuRespVOList?.find(item=> item?.productSkuId === Number(this.productSkuId))
      // if (productSkuInfo?.productCommunityRespVO) {
      //   this.$emit('coursePullCb', true)
      // }
    },
    async getBuyInfo() {
      if (!this.userInfo.id) {
        this.isBuy = false;
        return;
      }
      const { code, data } = await reqIsBuyProduct(this.productId);
      if (code === 0 && data.length) {
        this.isBuy = true;
      } else {
        this.isBuy = false;
      }
    },
    async goToCourse() {
      await this.getBuyInfo();
      if (this.helpStatus === 1 && !this.isBuy) { // 助力成功 但是开课未成功
        this.$toast.fail('课程发放中，请稍后再试');
      } else if (this.type === 'home' || this.isBuy) { // 首页 或者 已拥有的可以去到详情页
        if (this.$root.$data.isApp) {
          this.$sendToApp('goCourseDetail', Number(this.productId), false);
          return;
        }
        sessionStorage.setItem('back', 'back');
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: this.productId,
          },
        });
      }
    },
  },
  created() {
    this.courseDetail();
    this.getBuyInfo();
  },
};
</script>
<style scoped lang="scss">
.coursePullComponent {
    position: relative;
    width: 686px;
    min-height: 600px;
    margin: 48px auto;
    padding: 95px 16px 10px;
    background: url('../../../assets/img/pullNew/coursePullBg.png') no-repeat;
    background-size: 100% 100%;
    img {
        width: 654px;
        height: 472px;
        border-radius: 40px;
    }
    p {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 60px;
        margin-top: 10px;
        color: #fff;
        font-size: 28px;
        background: #F5001E;
        border: 2px solid #FF566B;
        border-radius: 18px;
    }
}
</style>
